// extracted by mini-css-extract-plugin
export var boxItems = "_7f-1";
export var boxItemsLg = "_7f-2";
export var button = "_7f-7";
export var buttonHoverless = "_7f-9";
export var buttonLg = "_7f-8";
export var filterGroupBox = "_7f-0";
export var icon = "_7f-3";
export var iconSecondary = "_7f-6";
export var iconWrapper = "_7f-4";
export var iconWrapperLg = "_7f-5";
export var truncatedLabel = "_7f-a";